import React from "react";
import {
  Truck,
  Headphones,
  BadgeDollarSign,
  ThumbsUp,
} from "lucide-react";

const TrustFactors: React.FC = () => {
  const factors = [
    {
      icon: Truck,
      title: "Free Shipping",
      description: "Free shipping over $100",
      color: "text-accent",
      bgColor: "bg-section-surface",
    },
    {
      icon: Headphones,
      title: "Support",
      description: "Top quality Support",
      color: "text-accent",
      bgColor: "bg-section-surface",
    },
    {
      icon: BadgeDollarSign,
      title: "Payment on Delivery",
      description: "Pay when you receive your order",
      color: "text-accent",
      bgColor: "bg-section-surface",
    },
    {
      icon: ThumbsUp,
      title: "Quality Products",
      description: "We Insure Product Quality",
      color: "text-accent",
      bgColor: "bg-section-surface",
    },
  ];

  return (
    <div className="w-full py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex gap-4 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-2 sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:gap-6 sm:overflow-visible sm:pb-0">
          {factors.map((factor, idx) => {
            const Icon = factor.icon;
            return (
              <div
                key={idx}
                className="min-w-60 shrink-0 snap-start flex flex-col items-center text-center p-5 sm:p-6 rounded-lg border border-section-card-border hover:border-accent hover:shadow-[0_0_16px_rgba(201,169,110,0.15)] transition-all duration-300 bg-section-card-bg hover:bg-section-surface sm:min-w-0 sm:shrink"
              >
                <div className={`${factor.bgColor} p-4 rounded-full mb-4`}>
                  <Icon
                    className={`w-8 h-8 ${factor.color}`}
                    strokeWidth={1.5}
                  />
                </div>
                <h3 className="text-lg font-bold text-section-text mb-2">
                  {factor.title}
                </h3>
                <p className="text-sm text-section-muted">{factor.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default TrustFactors;
